import React from 'react';
import { FJ190 } from '../../../services/j208Api';
import LookupField from '../../../components/LookupField';

interface Tab1Props {
  isEditing: boolean;
  getField: (key: keyof FJ190) => FJ190[keyof FJ190];
  setField: (key: keyof FJ190, value: FJ190[keyof FJ190]) => void;
}

const Tab1BasicInfo: React.FC<Tab1Props> = ({ isEditing, getField, setField }) => {
  const isDisabled = !isEditing;

  return (
    <div className="j208-tab1">
      <div className="form-section">
        <span className="section-tag">基本資料</span>
        <div className="form-grid">
          <label data-contract-field="fj190_23">入單人員</label>
          <input
            type="text"
            maxLength={8}
            readOnly
            value={getField('fj190_23') as string}
            style={{ maxWidth: 120 }}
          />

          <label data-contract-field="fj190_30">單據來源</label>
          <select
            disabled
            value={getField('fj190_30') as number ?? 0}
            onChange={e => setField('fj190_30', parseInt(e.target.value) || 0)}
            style={{ maxWidth: 140 }}
          >
            <option value={0}>--</option>
            <option value={1}>研發採購單</option>
            <option value={2}>研發托工單</option>
          </select>

          <label data-contract-field="fj190_10">採購/托工單</label>
          <LookupField
            lookupType="rdPurchaseOrder"
            maxLength={12}
            disabled
            value={(getField('fj190_10') as string) || ''}
            onChange={(code) => setField('fj190_10', code)}
            onCodeConfirm={(code) => setField('fj190_10', code)}
            style={{ maxWidth: 140 }}
          />

          <label data-contract-field="fj190_24">廠商代號</label>
          <LookupField
            lookupType="supplier"
            maxLength={12}
            disabled
            value={(getField('fj190_24') as string) || ''}
            onChange={(code) => setField('fj190_24', code)}
            onCodeConfirm={(code) => setField('fj190_24', code)}
            style={{ maxWidth: 140 }}
          />

          <label data-contract-field="fj190_25">工繳代號</label>
          <LookupField
            lookupType="contractorCode"
            maxLength={6}
            disabled
            value={(getField('fj190_25') as string) || ''}
            onChange={(code) => setField('fj190_25', code)}
            onCodeConfirm={(code) => setField('fj190_25', code)}
            style={{ maxWidth: 100 }}
          />

          <label data-contract-field="fj190_27">幣別</label>
          <LookupField
            lookupType="currency"
            maxLength={3}
            disabled
            value={(getField('fj190_27') as string) || ''}
            onChange={(code) => setField('fj190_27', code)}
            onCodeConfirm={(code) => setField('fj190_27', code)}
            style={{ maxWidth: 60 }}
          />

          <label className="required" data-contract-field="fj190_12">繳庫庫位</label>
          <LookupField
            lookupType="warehouse"
            maxLength={5}
            disabled={isDisabled}
            value={(getField('fj190_12') as string) || ''}
            onChange={(code) => setField('fj190_12', code)}
            onCodeConfirm={(code) => setField('fj190_12', code)}
            style={{ maxWidth: 100 }}
          />

          <label data-contract-field="fj190_26">工繳計價方式</label>
          <select
            disabled={isDisabled}
            value={getField('fj190_26') as number ?? 0}
            onChange={e => setField('fj190_26', parseInt(e.target.value) || 0)}
            style={{ maxWidth: 140 }}
          >
            <option value={0}>--</option>
            <option value={1}>計量</option>
            <option value={2}>計缸</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default Tab1BasicInfo;
